import { useCallback } from 'react';
import { httpPost } from '../../../../components/utils';
import { ServiceAccount } from '../ServiceAccountsTypes';
import { showAlert } from '@silverfort/sf-components';

export interface CreateBulkPolicy {
    createBulkPolicy: () => Promise<void>;
}

export const useCreateBulkPolicy = (selectedSAs: ServiceAccount[], action: string, sendToSiem: boolean): CreateBulkPolicy => {
    const createBulkPolicy = useCallback(async () => {
        const serviceAccountsById = selectedSAs.reduce((result, sa) => {
            result[sa.id] = sa;
            return result;
        }, {});
        try {
            await httpPost(`/ServiceAccountsV2/createBulkPolicy`, {
                serviceAccounts: serviceAccountsById,
                action: action,
                sendToSiem: sendToSiem
            });
        } catch (err) {
            console.error('failed to create bulk policy', err);
            showAlert('Failed to add policy', 'error');
        }
    }, [action, selectedSAs, sendToSiem]);

    return { createBulkPolicy };
};
